<!-- src/components/Layout.vue -->
<template>
  <div>
    <Header />
    <router-view />
    <Footer />
    <MessengerWidget />
  </div>
</template>

<script>
import Header from "./Header.vue";
import Footer from "./Footer.vue";
import MessengerWidget from "./MessengerWidget.vue";

export default {
  name: "Layout",
  components: {
    Header,
    Footer,
    MessengerWidget
  }
};
</script>

<style scoped>
/* Add your styles here */
</style>
